import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '@/styles/brand-pages.css';

const MissionPage = () => {
  return (
    <div className="brand-page mission-page" data-testid="mission-page">
      <div className="brand-page__inner">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <Link to="/" className="brand-page__back">← Back</Link>
        </motion.div>

        <motion.h1 
          className="brand-page__headline"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          The Philosophy
        </motion.h1>

        <div className="brand-page__content">
          <motion.p 
            className="brand-page__lead"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Connection was never meant to feel this performative.
          </motion.p>

          <motion.p 
            className="brand-page__body"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            Endless swiping. Forced interaction.<br />
            Moments that pass without meaning.
          </motion.p>

          <motion.p 
            className="brand-page__body"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            NYMPHÉ was created as a response to that.
          </motion.p>

          <motion.p 
            className="brand-page__body"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            A space where attraction is felt — not chased.<br />
            Where attention is intentional — not scattered.<br />
            Where connection unfolds naturally, without pressure or noise.
          </motion.p>

          <motion.p 
            className="brand-page__body"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            This is not about more matches.<br />
            It's about the right ones.
          </motion.p>

          <motion.p 
            className="brand-page__closing"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.8 }}
          >
            Not louder. Not faster.<br />
            Just… aligned.
          </motion.p>
        </div>
      </div>
    </div>
  );
};

export default MissionPage;
